// extracted by mini-css-extract-plugin
export var alertIcon = "_tm-0";